import React from 'react';
import { AtomVariant } from 'src/types/UserInterface';
import styles from './Button.module.scss';
import cn from 'classnames';
import { AnchorType, ButtonType } from 'src/types/ClickElement';
import { Icon, IconNames } from 'src/app/shared/Icon/Icon';

interface ButtonShared {
  variant?: AtomVariant;
  prefix?: IconNames;
  suffix?: IconNames;
  disabled?: boolean;
  iconPadding?: boolean;
  tooltip?: string;
}

type ButtonProps = AnchorType & ButtonShared | ButtonType & ButtonShared;

export const Button: React.FC<ButtonProps> = (props) => {
  const { children, prefix, suffix, variant, disabled, iconPadding, tooltip } = props;
  const tooltipProps = tooltip ? { 'data-tooltip': tooltip } : {};
  const classnames = cn(styles['o-button'], {
    [styles[`o-button--${variant}`]]: variant,
    [styles['o-button--icon-padding']]: iconPadding,
    [styles['is-disabled']]: disabled,
    [styles['has-tooltip']]: tooltip,
  });

  const Content = () => {

    return (
      <React.Fragment>
        {prefix && <Icon icon={prefix} width={24} />}
        <span>{children}</span>
        {suffix && <Icon icon={suffix} width={24} />}
      </React.Fragment>
    );
  };

  switch (props.tag) {
    case 'a': {
      return (
        <a
          href={props.href}
          rel="noopener noreferrer"
          target={props.newWindow ? '_blank' : '_self'}
          className={classnames}
          {...tooltipProps}
        >
          <Content />
        </a>
      );
    }
    case 'button': {
      return (
        <button type={props.type} onClick={props.onClick} className={classnames} disabled={disabled} {...tooltipProps}>
          <Content />
        </button>
      );
    }
    default:
      throw new Error('This is not a valid tag for a button.');
  }
};
